import React, { useState } from 'react';
import { 
    Divider,
    IconButton,
    Grid,
    MenuItem,
    Paper,
    TextField,
    withWidth
} from '@material-ui/core';
import { 
    Cached as CachedIcon,
    CheckCircle as CheckCircleIcon,
    EmojiObjects as EmojiObjectsIcon,
    Search as SearchIcon 
} from '@material-ui/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { 
    Alert as AlertAntd,
    Button as ButtonAntd,
    Popconfirm, 
    Switch as SwitchAntd,
    Tooltip as TooltipAntd,
} from 'antd';

import {
    KeyOutlined as KeyOutlinedIcon,
    LoadingOutlined as LoadingOutlinedIcon,
    SyncOutlined as SyncOutlinedIcon,
} from '@ant-design/icons';
import GenerarPassLite from '../helpers/GenerarPassLite';
import Swal from 'sweetalert2';

const ChangePass = ({widthWin})=>{
    const { enqueueSnackbar } = useSnackbar();
    const [ isChangeWifi, setChangeWifi ] = useState(false);
    const [ getWifi, setWifi ] = useState({
        Name:'',
        Pass:''
    });
    const [ getW, setW ] = useState({
        CodigoG:'',
        CodigoC:''
    });
    const [ getServicios, setServicios ] = useState([]);

    const [ DatosD, setDatosD ] = useState({
        CI:'',
        idCliente:'',
        Servicio:'',
        isMultipleServices:false,
    });

    const [ getValidacion, setValidacion ] = useState({
        isWhatsapp:false,
        isValiding:false,
        isValiding2:false,
        isClientValidate:false,
    });

    const [ is5G, set5G ] = useState(false);

    const handleWifi = ({target})=>{ setWifi({...getWifi, [target.id]:target.value})};

    const handleChangeName = ()=>{
        setChangeWifi(true);
        if(DatosD.isMultipleServices){
            const elS = getServicios.filter(el=> el._id === DatosD.Servicio)[0];
            if(elS.isTelnet){
                const objeto = {};
                objeto.IPCLIENTE = elS.AddressIp;
                objeto.NAMEWIFI = getWifi.Name;
                objeto.idCliente = DatosD.idCliente;
                objeto.idServicio = elS._id;
                objeto.OnuMarca = elS.OnuMarca;
                objeto.banda = is5G ? '5G' : '2.4G';
                objeto.Onu = elS.Onu;
                fetch('/api/HuaweiChangeNameWifi',{
                    method:'POST',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){
                        enqueueSnackbar(result.message, {variant:'success'});
                        setTimeout(()=>{
                            setChangeWifi(false);
                        },500)
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                        setTimeout(()=>{
                            setChangeWifi(false);
                        },500)
                    } 
                }); 
            }else{
                Swal.fire({
                    title:'EQUIPO NO COMPATIBLE, COMUNIQUESE CON SOPORTE TECNICO',
                    icon:'info',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    width:600,
                    confirmButtonText:'OK',
                    denyButtonText:'NO'
                });
                setChangeWifi(false);
            }
        }else{
            const elS = getServicios[0];
            if(elS.isTelnet){
                const objeto = {};
                objeto.IPCLIENTE = elS.AddressIp;
                objeto.NAMEWIFI = getWifi.Name;
                objeto.idCliente = DatosD.idCliente;
                objeto.idServicio = elS._id;
                objeto.OnuMarca = elS.OnuMarca;
                objeto.banda = is5G ? '5G' : '2.4G';
                objeto.Onu = elS.Onu;
                fetch('/api/HuaweiChangeNameWifi',{
                    method:'POST',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){
                        enqueueSnackbar(result.message, {variant:'success'});
                        setTimeout(()=>{
                            setChangeWifi(false);
                        },500)
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                        setTimeout(()=>{
                            setChangeWifi(false);
                        },500)
                    } 
                }); 
            }else{
                Swal.fire({
                    title:'EQUIPO NO COMPATIBLE, COMUNIQUESE CON SOPORTE TECNICO',
                    icon:'info',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    width:600,
                    confirmButtonText:'OK',
                    denyButtonText:'NO'
                });
                setChangeWifi(false);
            }
        }
    };

    const handleChangePass = ()=>{
        setChangeWifi(true);
        if(getWifi.Pass.length <= 7){
            alert('CLAVE WIFI DEBE SER MAYOR A 8 DIGITOS');
        }else{
            if(DatosD.isMultipleServices){
                const elS = getServicios.filter(el=> el._id === DatosD.Servicio)[0];
                if(elS.isTelnet){
                    const objeto = {};
                    objeto.IPCLIENTE = elS.AddressIp;
                    objeto.PASSWIFI = getWifi.Pass;
                    objeto.idCliente = DatosD.idCliente;
                    objeto.idServicio = elS._id;
                    objeto.OnuMarca = elS.OnuMarca;
                    objeto.banda = is5G ? '5G' : '2.4G';
                    objeto.Onu = elS.Onu;
                    fetch('/api/HuaweiChangePassWifi',{
                        method:'POST',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            enqueueSnackbar(result.message, {variant:'success'});
                            setTimeout(()=>{
                                setChangeWifi(false);
                            },500)
                        }else{
                            enqueueSnackbar(result.status, {variant:'error'});
                            setTimeout(()=>{
                                setChangeWifi(false);
                            },500)
                        } 
                    }); 
                }else{
                    Swal.fire({
                        title:'EQUIPO NO COMPATIBLE, COMUNIQUESE CON SOPORTE TECNICO',
                        icon:'info',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:600,
                        confirmButtonText:'OK',
                        denyButtonText:'NO'
                    });
                    setChangeWifi(false);
                }
            }else{
                const elS = getServicios[0];
                if(elS.isTelnet){
                    const objeto = {};
                    objeto.IPCLIENTE = elS.AddressIp;
                    objeto.PASSWIFI = getWifi.Pass;
                    objeto.idCliente = DatosD.idCliente;
                    objeto.idServicio = elS._id;
                    objeto.OnuMarca = elS.OnuMarca;
                    objeto.banda = is5G ? '5G' : '2.4G';
                    objeto.Onu = elS.Onu;
                    fetch('/api/HuaweiChangePassWifi',{
                        method:'POST',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            enqueueSnackbar(result.message, {variant:'success'});
                            setTimeout(()=>{
                                setChangeWifi(false);
                            },500)
                        }else{
                            enqueueSnackbar(result.status, {variant:'error'});
                            setTimeout(()=>{
                                setChangeWifi(false);
                            },500)
                        } 
                    }); 
                }else{
                    Swal.fire({
                        title:'EQUIPO NO COMPATIBLE, COMUNIQUESE CON SOPORTE TECNICO',
                        icon:'info',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:600,
                        confirmButtonText:'OK',
                        denyButtonText:'NO'
                    });
                    setChangeWifi(false);
                }
            }
        }
        
    };

    const handleBy5G = (checked)=>{ set5G(checked) };

    const handleValidar = ()=>{
        if(DatosD.CI.length <= 9){
            alert('CEDULA INCORRECTA');
        }else{ 
            setValidacion({...getValidacion, isValiding2:true, isValiding:true});
            const CodigoW = GenerarPassLite();
            const objeto = {...DatosD};
            objeto.CodigoW = CodigoW;
            setW({...getW, CodigoG:CodigoW});
            fetch('/api/ValidateClientWifi',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    enqueueSnackbar('CLIENTE SI EXISTE',{variant:'success'}); 
                    setServicios(result.Servicios);
                    if(result.message === 'MULTIPLE'){
                        Swal.fire({
                            title:'CLIENTE CON MULTIPLE SERVICIOS, SELECCIONE UNO',
                            icon:'info',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            width:600,
                            confirmButtonText:'OK',
                            denyButtonText:'NO'
                        })
                        setDatosD({...DatosD, isMultipleServices:true, idCliente:result.idCliente});
                        setValidacion({...getValidacion, isClientValidate:true, isValiding2:false, isValiding:false});
                    }else{
                        setDatosD({...DatosD, idCliente:result.idCliente});
                        setValidacion({...getValidacion, isClientValidate:true, isValiding2:false, isValiding:false})
                        
                    }
                }else{
                    enqueueSnackbar(result.status,{variant:'error'}); 
                    setValidacion({...getValidacion, isClientValidate:false, isValiding2:false, isValiding:false});
                    setDatosD({...DatosD, isMultipleServices:false});
                }
            });
        }
    };

    const handleDatos = ({target})=>{
        setDatosD({...DatosD, [target.id]:target.value});
    };

    const handleBlurName = ({target})=>{
        setWifi({...getWifi, Name:target.value.trim().split(' ').join('')});
    };

    const handleBlurPass = ({target})=>{
        if(target.value.length < 8){
            alert('CLAVE WIFI DEBE SER MAYOR A 8 DIGITOS');
        }
    };

    const handleBlurCI = ({target})=>{
        if(target.value.length < 10){
            alert('CEDULA INCORRECTA');
        }
    };

    const handleSelectMultiple = ({target})=>{
        setDatosD({...DatosD, Servicio:target.value});
    };

    const handleValidateWhatsapp = ()=>{
        if(getW.CodigoG === getW.CodigoC){
            setValidacion({...getValidacion, isWhatsapp:true});
            enqueueSnackbar('CLIENTE VALIDADO',{variant:'success'});
        }else{
            setValidacion({...getValidacion, isWhatsapp:false});
            enqueueSnackbar('CODIGO DE WHATSAPP NO COINCIDE',{variant:'error'});
        }
    };

    return(
        <Grid container justifyContent='center' alignItems='center'>
            <Grid item xs={12} sm={10} md={5} lg={4} style={{padding:10}}>
                <Paper 
                    elevation={2}
                    style={{
                        minHeight:500,
                        maxHeight:600,
                        overflowY:'auto',
                        overflowX:'hidden',
                        padding:10,
                    }}
                >
                    <Grid container justifyContent='center' alignItems='center' spacing={2}>
                        <Grid item xs={12} >
                            <Paper elevation={1} square >
                                <img src='images/logoLetras.png' alt='YOUNET' width='100%'/>
                            </Paper>
                        </Grid>
                        { !getValidacion.isClientValidate ?
                        <Grid item xs={12}>
                            <AlertAntd
                                message="CAMBIO DE NOMBRE Y CLAVE WIFI"
                                type="info"
                                showIcon
                            />
                        </Grid> : null}
                        <Grid item xs={12}>
                            <Grid container justifyContent='center' alignItems='center' spacing={3}>
                                <Grid item xs={10} md={8}>
                                    <TextField 
                                        id='CI'
                                        fullWidth
                                        disabled={getValidacion.isValiding}
                                        label='CEDULA'
                                        value={DatosD.CI || ''}
                                        onChange={handleDatos}
                                        variant='outlined'
                                        size='medium'
                                        margin='dense'
                                        placeholder='SIN ESPACIOS'
                                        onBlur={handleBlurCI}
                                        color='primary'
                                        onKeyPress={(event)=>{
                                            const code = event.keyCode || event.which;
                                            if(code === 13) handleValidar()
                                        }}
                                    />
                                </Grid>
                                {
                                    widthWin === 'xl' || widthWin === 'lg' ?
                                    <Grid item xs={10} md={4} style={{display:'flex', alignItems:'center', justifyContent:'center', paddingTop:11, paddingBottom:7}}>
                                        <ButtonAntd 
                                            block
                                            disabled={getValidacion.isValiding}
                                            icon={getValidacion.isValiding ? <LoadingOutlinedIcon/> : < KeyOutlinedIcon />}
                                            size='large'
                                            type="primary"
                                            onClick={handleValidar}

                                        >
                                            VALIDAR
                                        </ButtonAntd>
                                    </Grid>:
                                    <Grid item xs={2}>
                                        <TooltipAntd
                                           color='purple' title='BUSCAR CEDULA' 
                                        >
                                        </TooltipAntd>
                                        <IconButton
                                            disabled={getValidacion.isValiding}
                                            onClick={handleValidar}
                                            color='primary'
                                            size='small'
                                        >
                                            { getValidacion.isValiding ? <LoadingOutlinedIcon/> : < SearchIcon /> }
                                        </IconButton>
                                    </Grid>
                                }
                                
                            </Grid>
                        </Grid>
                        {
                            getValidacion.isClientValidate ?
                            <React.Fragment>
                                { !getValidacion.isWhatsapp ?
                                <Grid item xs={12}>
                                    <AlertAntd
                                        message="DIGITE EL CÓDIGO ENVIADO A SU WHATSAPP Y CORREO"
                                        type="success"
                                        showIcon
                                    />
                                </Grid>:null}
                                <Grid item xs={12}>
                                    <Grid container justifyContent='space-between' alignItems='center' spacing={2}>
                                        <Grid item xs={10}>
                                            <TextField 
                                                id='CodigoW'
                                                fullWidth
                                                label='CÓDIGO DE VALIDACIÓN'
                                                value={getW.CodigoC || ''}
                                                disabled={isChangeWifi}
                                                onChange={({target})=>{setW({...getW, CodigoC:target.value})}}
                                                variant='outlined'
                                                size='medium'
                                                margin='dense'
                                                placeholder='INGRESE EL CÓDIGO Y PRESIONE ENTER'
                                                onKeyPress={(event)=>{
                                                    const code = event.keyCode || event.which;
                                                    if(code === 13) handleValidateWhatsapp()
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TooltipAntd color='purple' title='CONTINUAR'>
                                                <IconButton onClick={handleValidateWhatsapp} color='primary' disabled={isChangeWifi}>
                                                    <CheckCircleIcon color='primary'/>
                                                </IconButton>
                                            </TooltipAntd>
                                        </Grid>
                                        
                                    </Grid>
                                    
                                </Grid>
                            </React.Fragment> : null
                        }
                        {
                            getValidacion.isWhatsapp ?
                            <React.Fragment>
                        
                            {   DatosD.isMultipleServices ?
                                <Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center', gap:5}}>
                                    <TextField 
                                        id='Servicios'
                                        fullWidth
                                        disabled={isChangeWifi}
                                        label='DIRECCION'
                                        value={DatosD.Servicio || ''}
                                        onChange={handleSelectMultiple}
                                        variant='outlined'
                                        size='medium'
                                        margin='dense'
                                        select
                                        color='primary'
                                        InputProps={{
                                            startAdornment: <EmojiObjectsIcon color='primary'/>,
                                        }}
                                    >
                                        {getServicios.map(el=>
                                            <MenuItem value={el._id} key={`Direccion_${el._id}`}>
                                                {el.Direccion}
                                            </MenuItem>)
                                        }
                                    </TextField>
                                    <IconButton onClick={()=>{setDatosD({...DatosD, Servicio:''})}} color='primary' disabled={isChangeWifi}>
                                        <CachedIcon/>
                                    </IconButton>
                                </Grid> : null
                            }
                            {
                                getValidacion.isClientValidate ?
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <TooltipAntd color='purple' title='SIN ESPACIOS EN BLANCO'>
                                            <TextField 
                                                id='Name'
                                                fullWidth
                                                label='NOMBRE WIFI'
                                                value={getWifi.Name || ''}
                                                onChange={handleWifi}
                                                variant='outlined'
                                                size='medium'
                                                margin='dense'
                                                placeholder='SIN ESPACIOS'
                                                onBlur={handleBlurName}
                                                disabled={isChangeWifi}
                                            />
                                        </TooltipAntd>
                                    </Grid>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={4}>
                                        <SwitchAntd disabled={isChangeWifi} checkedChildren="5G" unCheckedChildren="2.4G" checked={is5G} onChange={handleBy5G} />
                                    </Grid>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={8}>
                                        <Popconfirm
                                            title="DESEA CAMBIAR EL NOMBRE DE LA RED WIFI?"
                                            onConfirm={handleChangeName}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd 
                                                disabled={isChangeWifi }
                                                icon={isChangeWifi ? <LoadingOutlinedIcon/> :<SyncOutlinedIcon/>} 
                                                size='large' 
                                                type="primary"  
                                            >
                                                CAMBIAR NOMBRE
                                            </ButtonAntd>
                                        </Popconfirm>
                                        
                                    </Grid>
                                    <Grid item xs={12} style={{height:20}}>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={12}>
                                        <TooltipAntd color='purple' title='MINIMO 8 DIGITOS'>
                                            <TextField 
                                                id='Pass'
                                                fullWidth
                                                label='PASS WIFI'
                                                value={getWifi.Pass || ''}
                                                onChange={handleWifi}
                                                variant='outlined'
                                                size='medium'
                                                margin='dense'
                                                placeholder='MINIMO 8 DIGITOS'
                                                onBlur={handleBlurPass}
                                                disabled={isChangeWifi}
                                            />
                                        </TooltipAntd>
                                        
                                    </Grid>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={4}>
                                        <SwitchAntd disabled={isChangeWifi} checkedChildren="5G" unCheckedChildren="2.4G" checked={is5G} onChange={handleBy5G} />
                                    </Grid>
                                    <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={8}>
                                        <Popconfirm
                                            title="DESEA CAMBIAR EL PASS DE LA RED WIFI?"
                                            onConfirm={handleChangePass}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd 
                                                disabled={isChangeWifi}
                                                icon={isChangeWifi ? <LoadingOutlinedIcon/> :<SyncOutlinedIcon/>}
                                                size='large'
                                                type="primary"
                                            >
                                                CAMBIAR PASS
                                            </ButtonAntd>
                                        </Popconfirm>
                                    </Grid>
                                </React.Fragment> : null
                            }
                            </React.Fragment>:null
                        }
                        
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    )
};

function ChangePassWifi(props){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
            <ChangePass widthWin={props.width}/>
        </SnackbarProvider>
    );
};

export default withWidth()(ChangePassWifi);
